import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import AutoComplete from '../AutoComplete'
import { useSelectionSet } from '../../hooks/selection-set-functions'
import { useGetArbitriQuery } from '../../hooks/api-slice'

const SelectArbitro = () => {
  const { data: arbitri } = useGetArbitriQuery()
  const selectedArbitro = useSelector(state => state.selection.selectedArbitro)

  const { setSelectedArbitro } = useSelectionSet()

  const getOptionLabel = op => {
    const a = arbitri?.find(a => a?.id === (op?.id || op))
    return `${a?.nome} ${a?.cognome}`
  }

  return (
    <Grid size={{ xs: 12, md: 3 }}>
      <AutoComplete
        id='available-arbitri'
        label='Arbitro'
        value={selectedArbitro}
        options={arbitri}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={(op, value) => op?.id === value}
        disabled={!arbitri}
        onChange={i => setSelectedArbitro(i?.id)}
      />
    </Grid>
  )
}

export default SelectArbitro
